export default {
	sounds: [
		{ name: 'place', url: new URL('./audio/place1.ogg', import.meta.url), loop:false,volume:.2 },
		{ name: 'flow', url: new URL('./audio/flow.ogg', import.meta.url), loop:true,volume:1 },
		{ name: 'switch', url: new URL('./audio/switch2.ogg', import.meta.url), loop:false,volume:1 },
		{ name: 'noPlace', url: new URL('./audio/noPlace.ogg', import.meta.url), loop:false,volume:1 },
		{ name: 'destroy', url: new URL('./audio/destroy.wav', import.meta.url), loop:false,volume:.3 },
	],

	play(str) {
		let obj = this.sounds.find(sound => sound.name == str)
		let el = new Audio(obj.url)
		el.loop = obj.loop;
		el.volume = obj.volume
		el.play();
		return el
	}
}